const ShipViewReducer = (state = {}, action) => {
    switch (action.type) {
        case "getTestRecordsSuccess": {
            return Object.assign({}, state, {
                TestRecords: action.data,
            });
            break;
        }
        case "getTestRecordsFailure": {
            return Object.assign({}, state, {
                TestRecords: action.data,
            });
            break;
        }
        case "getShipDetailSuccess": {
            return Object.assign({}, state, {
                ShipDetail: action.data,
            });
            break;
        }
        case "getShipDetailFailure": {
            return Object.assign({}, state, {
                ShipDetail: action.data,
            });
            break;
        }
        case "postCrewMemberSuccess": {
            return Object.assign({}, state, {
                updatePendingTask: action.data,
            });
            break;
        }
        case "postCrewMemberFailure": {
            return Object.assign({}, state, {
                updatePendingTask: action.data,
            });
            break;
        }
        case "getShippingCompanyListSuccess": {
            return Object.assign({}, state, {
                ShippingCompanyList: action.data,
            });
            break;
        }
        case "getShippingCompanyListFailure": {
            return Object.assign({}, state, {
                ShippingCompanyList: action.data,
            });
            break;
        }
        default: {
            return state;
        }
    }
};
export default ShipViewReducer;
